"use client";

export default function ViewDemo() {
  return (
    <section
      style={{
        display: "flex",
        width: "100%",
        maxWidth: "1728px",
        height: "470px",
        padding: "10px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        margin: "0 auto",
        background:
          "linear-gradient(0deg, rgba(52, 78, 65, 0.85) 0%, rgba(52, 78, 65, 0.85) 100%), url('/images/Bloom-Wise_Mockup_video demo.webp') lightgray 50% / cover no-repeat",
      }}
    >
      <a
        href="#"
        className="w-20 h-20 rounded-full bg-white hover:bg-white/90 flex items-center justify-center transition-all shadow-2xl hover:shadow-3xl hover:scale-105"
      >
        <svg
          className="w-10 h-10 text-accent ml-1"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M8 5v14l11-7z" />
        </svg>
      </a>
      <span
        style={{
          color: "#FFF",
          fontFamily: "Abril Fatface",
          fontSize: "40px",
          fontWeight: 400,
          lineHeight: "50px",
        }}
      >
        Ver demo
      </span>
    </section>
  );
}
